import { render, staticRenderFns } from "./ArticleDetail.vue?vue&type=template&id=bb89c9f4&scoped=true&"
import script from "./ArticleDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleDetail.vue?vue&type=style&index=0&id=bb89c9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb89c9f4",
  null
  
)

export default component.exports